var _style, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.569,
    y1: 256.0003,
    x2: 456.431,
    y2: 256.0003
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M456.4,386.8c-12.8,0-23-9.2-24.1-21.2V46.3c0-17.3-14.1-31.4-31.4-31.4H93.3c-10.7,0-19.8,3.7-27.1,10.9 c-7.5,7.5-11.6,17.4-11.6,27.8v74.5c0,4,3.3,7.3,7.3,7.3h55.5V370c0,17.3,14.1,31.4,31.4,31.4H231c2.3,11.3,8.2,21.3,16.4,28.8 v59.6c0,2.5,1.3,4.8,3.3,6.1c1.2,0.8,2.6,1.2,4,1.2c1,0,2-0.2,3-0.6l26.2-11.8l25.5,11.8c2.3,1,4.9,0.9,7-0.5 c2.1-1.3,3.4-3.7,3.4-6.2v-59c8.6-7.6,14.7-17.8,17.1-29.4h119.5V386.8z M117.4,120.8H69.2V53.6c0-6.5,2.6-12.7,7.4-17.5 c4.5-4.5,9.9-6.6,16.8-6.6c13.5,0,24.1,10.6,24.1,24.1V120.8z M132,370V53.6c0-9.2-3.2-17.5-8.4-24.1h277.3 c9.1,0,16.8,7.7,16.8,16.8l0,320c0.7,7.8,3.7,14.8,8.3,20.5h-88.1c-1.9-28.1-25.3-50.4-53.9-50.4c-28.6,0-52,22.3-53.9,50.4h-81.3 C139.7,386.8,132,379.1,132,370z M305.2,478.4l-18.1-8.4c-1.9-0.9-4.1-0.9-6.1,0l-18.9,8.5v-38.7c6.7,3,14.1,4.7,21.9,4.7 c7.5,0,14.7-1.5,21.2-4.3V478.4z M284,429.9c-21.8,0-39.5-17.7-39.5-39.5c0-21.8,17.7-39.5,39.5-39.5c21.8,0,39.5,17.7,39.5,39.5 C323.4,412.2,305.8,429.9,284,429.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.2057,
    y1: 90.5049,
    x2: 373.8681,
    y2: 90.5049
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M175.2,111.4l21.9,16.1c1.3,0.9,2.8,1.4,4.3,1.4h143.2c1.6,0,3.1-0.5,4.3-1.4l21.9-16.1c1.9-1.4,3-3.6,3-5.9 v-30c0-2.3-1.1-4.5-3-5.9L349,53.6c-1.3-0.9-2.8-1.4-4.3-1.4H201.4c-1.6,0-3.1,0.5-4.3,1.4l-21.9,16.1c-1.9,1.4-3,3.6-3,5.9v30 C172.2,107.8,173.3,110,175.2,111.4z M186.8,79.2l17-12.5h138.4l17,12.5v22.6l-17,12.5H203.8l-17-12.5V79.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.7787,
    y1: 165.3974,
    x2: 351.9483,
    y2: 165.3974
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 197.8,
    y: 158.1,
    className: "st2",
    width: 154.2,
    height: 14.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.4363,
    y1: 201.199,
    x2: 387.0185,
    y2: 201.199
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 163.4,
    y: 193.9,
    className: "st3",
    width: 223.6,
    height: 14.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.4363,
    y1: 237.7319,
    x2: 387.0185,
    y2: 237.7319
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 163.4,
    y: 230.4,
    className: "st4",
    width: 223.6,
    height: 14.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.4363,
    y1: 273.537,
    x2: 387.0185,
    y2: 273.537
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 163.4,
    y: 266.2,
    className: "st5",
    width: 223.6,
    height: 14.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.4363,
    y1: 310.0699,
    x2: 387.0185,
    y2: 310.0699
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B95DC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8844F8"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 163.4,
    y: 302.8,
    className: "st6",
    width: 223.6,
    height: 14.6
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.72ada90297e2c034a9e912aa3979569d.svg";
export { ForwardRef as ReactComponent };